// extracted by mini-css-extract-plugin
export default {"container":"mE5aez6r","mobile":"mobile","attention":"HhacOCEf","logos":"gPQyBxId","title":"cjjTc1rh","buttons":"JkqsPR4e","description":"w8CjSMO9","agreement":"yRI4ETXa"};